function formatCurrency(
  val: string | number,
  hideCurrencyLabel = false
): string {
  const stringValue = val.toString().replace("−", "-");
  const float = parseFloat(stringValue);
  const formatter = new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  });

  const formatResult = formatter.format(float).toString();

  if (hideCurrencyLabel) return formatResult.substring(3);
  return formatResult;
}

export default formatCurrency;
